import React from 'react';

const LoadingSpinner = ({ message = 'Loading...' }) => (
  <div className="flex flex-col items-center justify-center py-12">
    <div className="animate-spin rounded-full h-8 w-8 border-2 border-brand-gold border-t-transparent" />
    <p className="mt-3 text-sm text-gray-500 dark:text-gray-400">{message}</p>
  </div>
);

export default LoadingSpinner;
